export enum SeverityBotColors {
  RUNNING = "#04D538",
  UNSUCCESSFUL_START = "#EF4444",
  OPENING = "#A2FF00",
  ERROR = "#EF4444",
  CLOSING = "#A2FF00",
  WAITING_TO_BE_CLOSED = "#A2FF00",
  NO_LOSS_CLOSING = "#A2FF00",
  SHUTDOWN = "#3A1890",
}
